/* ==========================================================================
   Detail B: the snap in section, the Detail A grammar of the pad film. A
   dash-dot ring on the left hook's window and a leader to a bubble left of
   the housing, where one wall is drawn about 4x: the housing (dark, +45°
   hatch) with its lead-in chamfer and undercut window, the cap (two steps
   lighter, -45° hatch — the adjacent part) with the cantilever hook. The cap comes
   down with `cap-dy`, the hook bends about its root with `hook`,
   rides the chamfer, slides down the wall and snaps into the window; the
   click ticks print at the catch. Bubble-local stage units, centre (915,
   560); the cap is drawn seated and offset by its height above the seat.
   ========================================================================== */

const CLICK_BUBBLE = { x: 915, y: 560 }

const HOUSING = 'M-130 -55H-29.5L-8 -33.5V22.4H-33.8V65.4H-8V130H-130Z'
const POCKET = 'M-8 -55H130V130H-8Z'
const CAP_WALL = 'M-38.1 -55H-20.9V-130H-38.1Z'
const CAP_LEDGE = 'M-20.9 -76H12V-64H-20.9Z'
const HOOK = 'M-7 -64H12V56H-7V52L-28.5 30V24.4H-7Z'
/* Mirror images (x negated) for the -45° hatch drawn under scale(-1 1). */
const CAP_HATCH = 'M38.1 -55H20.9V-130H38.1ZM20.9 -76H-12V-64H20.9Z'
const HOOK_HATCH = 'M7 -64H-12V56H7V52L28.5 30V24.4H7Z'
const TICKS = 'M-38 18L-52 8M-40 26H-56M-38 34L-52 44'

function CapSection({ id }) {
  return (
    <g className="pp-bcap">
      <path className="f-gF" d={`${CAP_WALL}${CAP_LEDGE}`} />
      <g transform="scale(-1 1)">
        <path d={CAP_HATCH} fill={`url(#${id}hatch)`} />
      </g>
      <g className="pp-bhook">
        <path className="f-gF" d={HOOK} />
        <g transform="scale(-1 1)">
          <path d={HOOK_HATCH} fill={`url(#${id}hatch)`} />
        </g>
        <path className="l-crest" d="M-28.5 24.4H-7" />
      </g>
    </g>
  )
}

/** The ring, leader and bubble of Detail B (stage units). */
export function ClickBubble({ id }) {
  const { x, y } = CLICK_BUBBLE
  return (
    <g className="pp-detail-b">
      <g className="pp-detail-src">
        <circle className="l-anno l-dd" cx="1050" cy="624" r="12" />
        <path className="l-leader" d="M1039.2 618.9L987.3 594.3" />
      </g>
      <g transform={`translate(${x} ${y})`}>
        <g className="pp-bbubble">
          <circle className="f-floor l-bubble" r="80" />
          <g clipPath={`url(#${id}bclip)`}>
            <path className="f-poly" d={POCKET} />
            <path className="f-pW" d={HOUSING} />
            <path d={HOUSING} fill={`url(#${id}hatch)`} />
            <path className="l-crest" d="M-130 -55H-29.5L-8 -33.5" />
            <CapSection id={id} />
            <g className="pp-bticks">
              <path className="l-knock" d={TICKS} />
              <path className="l-tick" d={TICKS} />
            </g>
          </g>
        </g>
      </g>
    </g>
  )
}

export function ClickBubbleDefs({ id }) {
  return (
    <clipPath id={`${id}bclip`} clipPathUnits="userSpaceOnUse">
      <circle r="78" />
    </clipPath>
  )
}
